import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { AlertOctagon, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

// Today's most disrupted departure airports (live FlightAware disruption counts)
export default function DisruptionBoard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const r = await fetch(`${API}/airport/disruptions`);
        if (r.ok && !cancel) setData(await r.json());
      } catch {
        /* section simply doesn't render */
      }
    })();
    return () => { cancel = true; };
  }, []);

  if (!data?.airports?.length) return null;

  return (
    <Card className="border-slate-200 bg-white mt-10" data-testid="disruption-board">
      <CardContent className="p-5 sm:p-6">
        <div className="flex items-center gap-2 mb-1">
          <AlertOctagon className="w-4 h-4 text-rose-500" />
          <h2 className="heading text-base sm:text-lg font-semibold text-slate-900">
            Most disrupted airports today
          </h2>
        </div>
        <p className="text-xs text-slate-500 mb-4">
          Worldwide departure delays and cancellations so far today, from live FlightAware data.
        </p>
        <ul className="divide-y divide-slate-100">
          {data.airports.map((a, idx) => {
            const inner = (
              <div className="flex items-center justify-between gap-3 py-2.5">
                <div className="flex items-center gap-3 min-w-0">
                  <span className="text-[11px] font-bold text-rose-500 w-5 text-right">#{idx + 1}</span>
                  <span className="font-mono font-semibold text-slate-900">{a.code || a.icao}</span>
                  <span className="text-sm text-slate-500 truncate">{a.name}</span>
                </div>
                <div className="flex items-center gap-3 text-xs whitespace-nowrap">
                  <span className="text-amber-600 font-medium">{a.delays} delayed</span>
                  <span className="text-rose-600 font-medium">{a.cancellations} cancelled</span>
                  {a.has_guide && <ChevronRight className="w-3.5 h-3.5 text-slate-300" />}
                </div>
              </div>
            );
            return (
              <li key={a.icao || a.code}>
                {a.has_guide ? (
                  <Link to={`/?airport=${a.code}`} className="block hover:bg-slate-50 -mx-2 px-2 rounded" data-testid={`disruption-row-${a.code}`}>
                    {inner}
                  </Link>
                ) : (
                  <div data-testid={`disruption-row-${a.code || a.icao}`}>{inner}</div>
                )}
              </li>
            );
          })}
        </ul>
      </CardContent>
    </Card>
  );
}
